import { toggleButtonClasses } from "../../../components/atoms/ToggleButton/index.js";
import { ZERO, SESQUIPLE, QUADRUPLE } from "../../../constants/numbers.consts.js";
export default {
    styleOverrides: {
        root: ({ theme }) => ({
            [`& .${toggleButtonClasses.root}`]: {
                borderRadius: ZERO,
                color: theme.vars.palette.text.primary,
            },
            [`& button.${toggleButtonClasses.selected}`]: {
                backgroundColor: theme.vars.palette.surface.containerHighest,
            },
            [`& .${toggleButtonClasses.standard}`]: {
                border: ZERO,
                display: "flex",
                justifyContent: "space-between",
                padding: theme.spacing(SESQUIPLE, QUADRUPLE),
                textAlign: "left",
                textTransform: "none",
                width: "100%",
            },
        }),
    },
};
